"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = require("./base");

var RootBlock =
/*#__PURE__*/
function (_BlockContainer) {
  babelHelpers.inherits(RootBlock, _BlockContainer);

  function RootBlock() {
    babelHelpers.classCallCheck(this, RootBlock);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(RootBlock).apply(this, arguments));
  }

  return RootBlock;
}(_base.BlockContainer);

exports.default = RootBlock;